
import * as defaultImport from "lodash/isNumber";
export * from "lodash/isNumber";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
